export const REDUX_SET =
  '/redux/container/TurnoverCancelReservationContainer/set';
export const REDUX_RESET =
  '/redux/container/TurnoverCancelReservationContainer/reset';
